<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="job">Job</label>
                    <input id="job" type="text" class="form-control" [(ngModel)]="target.job" name="job" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="ownerId">Owner</label>
                    <wj-combo-box
                        id="ownerId"
                        [(ngModel)]="target.ownerId"
                        name="ownerId"
                        [itemsSource]="ownersList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bidTypeId">Bid Type</label>
                    <wj-combo-box
                        id="bidTypeId"
                        [(ngModel)]="target.bidTypeId"
                        name="bidTypeId"
                        [itemsSource]="jobTypesList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="countyId">County</label>
                    <wj-combo-box
                        id="countyId"
                        [(ngModel)]="target.countyId"
                        name="countyId"
                        [itemsSource]="countiesList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
